module.exports = __webpack_public_path__ + "img/menzhen.874a17a3.png";